import { render, staticRenderFns } from "./StatisticsMarksByFacultyView.vue?vue&type=template&id=35f7d35b"
import script from "./StatisticsMarksByFacultyView.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByFacultyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports